export default __webpack_public_path__ + "images/LIZ.27b6cba.png";